import { otmsHttp } from '@/utils/http/index';

/**
 * 分页查询(组织/商户统一接口)
 * https://yapi.ops.yunlizhi.cn/project/295/interface/api/36184
 */

export function mainManagePage(data, params) {
  return otmsHttp.post('/crm-plus/main/manager/page', data, {
    params,
  });
}

/**
 * 新增/编辑
 * https://yapi.ops.yunlizhi.cn/project/295/interface/api/36192
 */

export function mainManageUpsert(data) {
  return otmsHttp.post('/crm-plus/main/manager/upsert', data);
}

/**
 * 详情
 * https://yapi.ops.yunlizhi.cn/project/295/interface/api/36176
 */

export function mainManageDetail(data) {
  return otmsHttp.post('/crm-plus/main/manager/detail', data);
}

/**
 * 删除
 * https://yapi.ops.yunlizhi.cn/project/295/interface/api/36196
 */

export function mainManageDelete(data) {
  return otmsHttp.post('/crm-plus/main/manager/delete', data);
}

/**
 * 主体授权客户分页查询
  https://yapi.ops.yunlizhi.cn/project/295/interface/api/36164
 */

export function mainManageAuthPage(data, params) {
  return otmsHttp.post('/crm-plus/main_manager/auth/page', data, { params });
}

/**
 * 取消授权
  https://yapi.ops.yunlizhi.cn/project/295/interface/api/36172
 */

export function mainManageAuthCancel(data) {
  return otmsHttp.post('/crm-plus/main_manager/auth/cancel', data);
}

/**
 * 添加授权
  https://yapi.ops.yunlizhi.cn/project/295/interface/api/36168
 */

export function mainManageAuthAppend(data) {
  return otmsHttp.post('/crm-plus/main_manager/auth/append', data);
}
